import React, { useState } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Paper, Typography, Grid, Button, IconButton } from "@material-ui/core";

import { styles } from "./BoxItem.styles";
import SensorItem from "../Sensor/SensorItem";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

function BoxItem({
  classes,
  selectedProject,
  box,
  onEditBox,
  onDeleteBox,
  onSensorSelected,
  onAddSensor,
}) {
  const [hover, sethover] = useState(false);
  return (
    <Paper
      className={classes.root}
      onMouseOver={() => sethover(true)}
      onMouseOut={() => sethover(false)}
    >
      <Typography variant="h3" className={classes.title}>
        {box.designation}{" "}
        <IconButton
          aria-label="edit"
          disableRipple
          size="small"
          onClick={() => onEditBox(box)}
          className={classes.icon}
          style={hover ? { display: "inline" } : { display: "none" }}
          // style={{ display: "inline" }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          aria-label="edit"
          disableRipple
          size="small"
          onClick={() => onDeleteBox(box)}
          className={classes.icon}
          style={hover ? { display: "inline" } : { display: "none" }}
          // style={{ display: "inline" }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Typography>
      <Typography variant="h6" className={classes.description}>
        {box.description}
      </Typography>
      <Grid container spacing={1}>
        {box.sensors.map((sensor) => (
          <Grid item xs={6} sm={4} key={sensor.id}>
            <SensorItem
              selectedProject={selectedProject}
              sensor={sensor}
              onSensorSelected={onSensorSelected}
            />
          </Grid>
        ))}
        <Grid item xs={6} sm={4}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={() => onAddSensor(box.id)}
          >
            Add New Sensor
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default withStyles(styles)(BoxItem);
